import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { bindActionCreators } from "redux";
import moment from "moment";

import MyStatsGraph from "../MyStatsGraph";

import {
  handleClick,
  handleDataFromTime,
  countOccurrence,
} from "./graphHelpers";
import commonActions from "../../Actions/commonActions";

class TransactionServiceGraphTeam extends Component {
  state = {
    data: [],
    timePeriod: "month",
  };

  async componentDidMount() {
    const { user, commonActions } = this.props;
    await commonActions.getTransactionServiceByTeamId(user.teamId);
    this.setState({
      ...this.state,
      data: handleDataFromTime(
        this.props.transactionDataTeam,
        moment().startOf("month"),
        moment().endOf("month"),
        "activationDate"
      ),
    });
  }

  clickFunc = (event) => {
    const { value } = event.target;

    this.setState({
      ...this.state,
      data: handleClick(
        event,
        this.props.transactionDataTeam,
        "activationDate"
      ),
    });

    this.setState((state) => ({ timePeriod: value }));
  };

  render() {
    const { transactionDataTeam, t } = this.props;

    if (!transactionDataTeam) {
      return null;
    }

    return (
      <MyStatsGraph
        typeOfGraph='Bar'
        onClick={(event) => this.clickFunc(event)}
        title={t("graph.transactionServicesTeam")}
        labels={countOccurrence(this.state.data, "name").map(
          ({ name }) => name
        )}
        data={countOccurrence(this.state.data, "name").map(
          ({ occurrence }) => occurrence
        )}
        backgroundColor={["rgb(9, 116, 179)"]}
        timePeriod={this.state.timePeriod}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.CommonReducer.user,
    transactionDataTeam: state.CommonReducer.transactionServices,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(TransactionServiceGraphTeam));
